/*------------------------------------------------
// File Name:PDM_MA_PatientInfo.js
// File Description:PDM_MA_PatientInfo API方法js接口
// Author:zxl
// Create Time:2023/07/10 17:29:38
//------------------------------------------------*/
import { axios } from '@/utils/request'

const api = {
   _maPatientinfo: "/PDM_MA_PatientInfo"
}

export default api


//-------------------创建对象-------------------
export function CreatePDM_MA_PatientInfoEntity(parameter) {
    return axios({
        url: api._maPatientinfo + "/CreatePDM_MA_PatientInfoEntity",
        method: 'post',
        data: parameter
    })
}

//-------------------获取列表-------------------
export function GetPDM_MA_PatientInfoList(parameter) {
    return axios({
        url: api._maPatientinfo + "/GetPDM_MA_PatientInfoList",
        method: 'post',
        data: parameter
    })
}

//-------------------分页获取列表---------------
export function GetPDM_MA_PatientInfoListByPage(parameter) {
    return axios({
        url: api._maPatientinfo + "/GetPDM_MA_PatientInfoListByPage",
        method: 'post',
        data: parameter
    })
}

//-------------------获取对象---------------
export function GetPDM_MA_PatientInfoEntity(parameter) {
    return axios({
        url: api._maPatientinfo + "/GetPDM_MA_PatientInfoEntity",
        method: 'post',
        data: parameter
    })
}


//-------------------保存对象---------------
export function UpdatePDM_MA_PatientInfoEntity(parameter) {
    return axios({
        url: api._maPatientinfo+ "/UpdatePDM_MA_PatientInfoEntity",
        method: 'post',
        data: parameter
    })
}

//-------------------删掉对象---------------
export function DeletePDM_MA_PatientInfoEntity(parameter) {
    return axios({
        url: api._maPatientinfo + "/DeletePDM_MA_PatientInfoEntity",
        method: 'post',
        data: parameter
    })
}
